import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationParameterTypeHttpResponse {
  id: number;
  referenceGuid: string;
  parameterTypeName: string;
  inputType: number;
  inputTypeName: string;
  valueType: number;
  valueTypeName: string;
}

export class NotificationParameterType {
  constructor(
    public id: number,
    public referenceGuid: string,
    public parameterTypeName: string,
    public inputType: number,
    public inputTypeName: string,
    public valueType: number,
    public valueTypeName: string,
  ) { }

  public static adapt(data: INotificationParameterTypeHttpResponse) {
    return new this(
      data.id,
      data.referenceGuid,
      data.parameterTypeName,
      data.inputType,
      data.inputTypeName,
      data.valueType,
      data.valueTypeName
    );
  }

  public static createBlank() {
    return new this(0, '', '', 0, '', 0, '');
  }
}

export const NotificationParameterTypeColumns: Readonly<EvideTableColumn[]> = [
  {
    key: 'parameterTypeName',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Parameter Type',
    displayValue: true,
    required: true,
    required_error: 'Parameter Type is Required',
    sortable: true
  },
  {
    key: 'inputType',
    type: EvideTableColumnType.Number,
    compType: EvideTableColumnComponent.Dropdown,
    isFormField: true,
    isFormEditableField: true,
    title: 'Input Type',
    hideInList: true,
    required: true,
    placeholder: 'Please Select Input Type',
    required_error: 'Input Type is Required',
    sortable: true
  },
  {
    key: 'inputTypeName',
    type: EvideTableColumnType.String,
    title: 'Input Type',
    displayValue: true,
    sortable: true,
    isFormEditableField: false
  },
  {
    key: 'valueType',
    type: EvideTableColumnType.Number,
    compType: EvideTableColumnComponent.Dropdown,
    isFormField: true,
    isFormEditableField: true,
    title: 'Value Type',
    hideInList: true,
    required: true,
    placeholder: 'Please Select Value Type',
    required_error: 'Value Type is Required',
    sortable: true
  },
  {
    key: 'valueTypeName',
    type: EvideTableColumnType.String,
    title: 'Value Type',
    displayValue: true,
    sortable: true,
    isFormEditableField: false
  },
  {
    key: 'referenceGuid',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Reference Guid',
    displayValue: true,
    required: true,
    required_error: 'Reference Guid is Required',
    sortable: true,
    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$'
  },
  {
    key: 'options',
    type: EvideTableColumnType.Options,
    matIcon: 'more_vert',
    title: 'Options',
    optionMenu: [
      {
        key: 'edit',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-pen',
        title: 'Edit',
        accessVisibility: {
          controllerKey: EAccess.NotificationParameterType,
          methodKey: EAccessMethod.Put
        }
      },
      {
        key: 'delete',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-trash-alt',
        title: 'Delete',
        accessVisibility: {
          controllerKey: EAccess.NotificationParameterType,
          methodKey: EAccessMethod.Delete
        }
      }
    ]
  }
];